import * as types from './personal-notes.types';

export const personalNotesPageSelectors: types.IPersonalNotesPageSelectors = {
  selectPersonalNotesIds: (state) => state.page.personalNotes.personalNotesIds,
};
